export default function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/iterableToArray.js
// module id = 912
// module chunks = 0